import React, {useContext} from 'react'
import styled from "styled-components";
import cardTop from "../../../assets/img/card_top.png";
import Spacer from "../../../components/Spacer";
import {StakeTopContext} from "../../../contexts/farm_provider/stake_top_provider";
import {getBalanceNumber} from "../../../utils/formatBalance";
import Value from "../../../components/Value";
import right from "../../../assets/img/right_s.png"
import line from "../../../assets/img/line.png"
import {PieChartWapWidget} from "../../../components/pic_chart/index";
import {Context as FarmsContext} from "../../../contexts/Farms";
import BigNumber from "bignumber.js";

export const StakeCardsTop: React.FC<{ stakedLength: number }> = (model) => {
    const {total, staked, averageRrturns, userAllStakeBalance,returns, leverage} = useContext(StakeTopContext);
    const {allReward} = useContext(FarmsContext);

    return (<Box>

        <StyleTopTitle> My Portfolio</StyleTopTitle>
        <StyleBottom>
            <StylePieRow>
                <PieChartWapWidget title="My Staking" key='Staked' totalNumner={getBalanceNumber(staked.times(4))} list={[{
                    name: 'My Staking',
                    value: getBalanceNumber(userAllStakeBalance.times(4)),
                    color: 'rgba(238, 35, 136, 1)'
                }, {
                    name: ' Total Staking',
                    value: getBalanceNumber(staked.minus(userAllStakeBalance).times(4)),
                    color: 'rgba(54, 67, 227, 1)'
                }]}>

                    <p className='sub_title'>My Staking</p>
                    <div className='staked' style={{fontSize:'20px',color:'rgba(255, 255, 255, .6)'}}> <Value value={getBalanceNumber(userAllStakeBalance.times(4))}/></div>
                    <p style={{width:'60%',height:'1px',backgroundColor:"rgba(32, 46, 83, 1)",marginBottom:'10px'}} />
                    <p className='sub_title'> Total Staking</p>
                    <div className='staked' style={{fontSize:'20px'}}> <Value value={getBalanceNumber(staked.times(4))}/></div>

                    {/*<p className='number20'>+{getBalanceNumber(userAllStakeBalance.times(4))}</p>*/}
                </PieChartWapWidget>
                <Spacer/>
                <PieChartWapWidget title="My Rewards" key='Rewards' totalNumner={allReward} list={[{
                    name: 'My Rewards',
                    value: getBalanceNumber(total),
                    color: 'rgba(8, 208, 196, 1)'
                }, {
                    name: 'Total Rewards',
                    value: getBalanceNumber(new BigNumber(allReward).minus(total)),
                    color: 'rgba(42, 59, 104, 1)'
                }]}>
                    <p className='sub_title'>My Rewards</p>
                    <div className='staked' style={{fontSize:'20px'}}> <Value value={getBalanceNumber(total)} decimals={2}/></div>
                    <p style={{width:'60%',height:'1px',backgroundColor:"rgba(32, 46, 83, 1)",marginBottom:'10px'}} />
                    <p className='sub_title'>Total Provided</p>
                    <div className='staked' style={{fontSize:'20px',color:'rgba(255, 255, 255, .6)'}}> <Value value={getBalanceNumber(new BigNumber(allReward))}/></div>
                </PieChartWapWidget>
            </StylePieRow>

            <Spacer/>

            <StyleRowWap>
                <TopRow>
                    <BottomCell>
                        <StyleTitle>Total Products Staked:</StyleTitle>
                        <StyleSubTitle>{model.stakedLength}</StyleSubTitle>
                    </BottomCell>
                    <BottomCell>
                        <StyleTitle>Leverage Used: </StyleTitle>
                        <StyleSubTitle>{leverage ? (leverage.toNumber() * 100).toFixed(2) : 0}<Unit>%</Unit></StyleSubTitle>
                    </BottomCell>


                </TopRow>
                <Line><p/></Line>
                <TopRow>
                    <BottomCell>
                        <StyleTitle>Estimated Returns (Epoch):</StyleTitle>
                        <StyleSubTitle>

                            <Value value={getBalanceNumber(averageRrturns)} decimals={2}/>
                            <p style={{width: '5px'}}/>
                            <Unit>Nsure</Unit>
                        </StyleSubTitle>
                    </BottomCell>
                    <BottomCell>
                        <StyleTitle>Estimated Returns APY:</StyleTitle>

                        <StyleSubTitle>
                            {returns.toNumber().toFixed(2)}%
                            <Unit></Unit>
                        </StyleSubTitle>
                    </BottomCell>
                </TopRow>

            </StyleRowWap>

        </StyleBottom>


        {/*   <CentenBox>
            <TotalRight>
                <h2><img src={right} alt=""/>Total Staked</h2>
                <Interval/>
                <h3>
                    <Value value={getBalanceNumber(staked.times(4))}/> <Unit>Nsure</Unit>
                </h3>
            </TotalRight>
            <StyleLine src={line} alt=""/>
            <TotalRight>
                <h2><img src={right} alt=""/>My Rewards</h2>
                <Interval/>

                <h3>
                    <Value value={getBalanceNumber(total)} decimals={2}/><Unit>Nsure</Unit>
                </h3>
            </TotalRight>
        </CentenBox>
        <TopRow>
            <BottomCell>
                <StyleTitle>Estimated Returns(14D):</StyleTitle>
                <StyleSubTitle><Value value={getBalanceNumber(averageRrturns)} decimals={2}/>
                    <Unit>Nsure</Unit></StyleSubTitle>
            </BottomCell>
            <Flex/>
            <BottomCell>
                <StyleTitle>Projected</StyleTitle>

                <StyleSubTitle>
                    <Description>Returns APY:</Description> {userAllStakeBalance.toNumber().toFixed(2)}%
                </StyleSubTitle>
            </BottomCell>
        </TopRow>
        <Spacer/>
        <TopRow>
            <BottomCell>
                <StyleTitle>Leverage Used: </StyleTitle>
                <StyleSubTitle>{leverage ? (leverage.toNumber() * 100).toFixed(2) : 0}%</StyleSubTitle>
            </BottomCell>
            <Flex/>
            <BottomCell>
                <StyleTitle>Total Products </StyleTitle>
                <StyleSubTitle><Description>Staked:</Description>{model.stakedLength}</StyleSubTitle>
            </BottomCell>

        </TopRow>*/}


    </Box>);
};


const Line = styled.div`
    width: 70px;
    height: 60px;
    p{
        background-color: rgba(32, 46, 83, 1);
        width: 2px;
        height: 100%;
        margin: 0 auto;
    }
     @media (max-width: 768px) {
       height: 20px;
       p{
       display: none;
       }
    };
`;

export const StyleTopTitle = styled.h2`
height: 50px;
padding-left: 30px;
box-sizing: border-box;
background: #17254A;
border: 1px solid #273761;
border-bottom: 0;
box-shadow: 0 0 95px 0 rgba(45, 70, 146, 0.13);
border-radius: 4px 4px 0 0;
font-size: 20px;
font-weight: 400;
color: #FFFFFF;
line-height: 50px;

`;


const StyleBottom = styled.div`
background: #17254A;
border: 1px solid #273761;
box-shadow: 0 0 95px 0 rgba(45, 70, 146, 0.13);
border-radius:0 0 4px 4px;
padding: 30px 35px;
box-sizing: border-box;
@media (max-width: 768px) {
padding: 20px 0;
 }
`;

const StylePieRow = styled.div`
display: flex;
justify-content: space-between;
width: 100%;
@media (max-width: 768px) {
 flex-flow: column;
 }
`;

const StyleRowWap = styled.div`
display: flex;
justify-content: space-between;
width: 100%;
flex-flow: column;
align-items: center;
 @media (min-width: 768px) {
 flex-flow: initial;
    background: #142144;
    border: 1px solid #273761;
    border-radius: 4px;
  };
`;


const StyleTitle = styled.h2`
height: 13px;
font-size: 12px;
font-weight: 400;
color: ${(props) => props.theme.color.whites[100]};

`;


const StyleSubTitle = styled.h3`
display:flex;
width: 123px;
height: 25px;
font-size: 22px;
font-weight: 500;
color: #FFFFFF;
align-items: flex-end;
`;

const Box = styled.div`
  margin:0 auto;
    width: 100%;

  @media (max-width: 768px) {
  }`;


const Unit = styled.span`
display: inline-block;
font-size:16px;
`;


export const TopRow = styled.div`
    display:flex;
    flex: 1;
    align-items: center;
    padding:10px 20px;
    box-sizing: border-box;
    justify-content: space-around;
    @media (max-width: 768px) {
        background: #142144;
        border: 1px solid #273761;
        border-radius: 4px;
        width: 94%;
        margin: 0 auto;
    };
`;


export const BottomCell = styled.div`
height:80px;
box-sizing:border-box;
display:flex;
flex: 1;
justify-content: space-around;
flex-flow: column;
`;



